import { FOOD_TYPES, MAX_BUFFET_ORDER } from '~/constants/buffet'
import STORAGE_KEYS from '~/constants/localStorage'

// Hàm check item có phải buffet type hay không dựa vào food_type
export const isBuffetDishType = (food_type) => {
  return food_type === FOOD_TYPES.buffet_dish
}

// Hàm dùng để check disabled buffet dish còn lại trong màn index menu trong trường hợp số lượng lớn hơn 2 trong giỏ hàng
export const isDisabledBuffetItem = (quantity) => {
  return quantity >= MAX_BUFFET_ORDER
}

// Hàm kiểm tra xem có request buffet hay không?
export const checkHasBuffetRequest = (buffetRequestsTime = []) => {
  if (buffetRequestsTime && Array.isArray(buffetRequestsTime)) {
    const buffetRequestsTimeFiltered = buffetRequestsTime.filter((item) => item.serving_ended_at) // Chỉ lọc ra những buffet nào setting serving_time
    return buffetRequestsTimeFiltered.length > 0
  }

  return false
}

// Hàm để lưu dữ liệu buffet vào localStorage
export function saveBuffetToLocalStorage(buffetData) {
  localStorage.setItem(STORAGE_KEYS.BUFFET_DATA, JSON.stringify(buffetData))
}

// Hàm để lấy dữ liệu buffet từ localStorage
export function getBuffetFromLocalStorage() {
  const storedBuffet = localStorage.getItem(STORAGE_KEYS.BUFFET_DATA)
  try {
    return storedBuffet ? JSON.parse(storedBuffet) : []
  } catch (_e) {
    return []
  }
}

// Hàm map qua mảng buffet và trả về dạng name-serving_ended_at
const mapBuffets = (buffet = []) => {
  if (!buffet) return []
  return buffet.map((item) => `${item.name}-${item.serving_ended_at}`)
}

// Hàm để kiểm tra xem món buffet có mới không (dựa trên name và serving_ended_at)
export function checkForNewBuffet(buffetData, showPopupStartBuffet) {
  const storedBuffet = getBuffetFromLocalStorage()
  const storedBuffetMap = mapBuffets(storedBuffet)
  const buffetDataMap = mapBuffets(buffetData)

  // Lặp qua mảng buffet mà api trả về kiểm tra xem có buffet nào mới hay không
  const newBuffet = buffetDataMap.filter((item) => !storedBuffetMap.includes(item))

  // Nếu có món buffet mới
  if (newBuffet.length > 0) {
    // Hiển thị popup Start Buffet
    showPopupStartBuffet(true)

    // Lưu lại dữ liệu buffet mới vào localStorage sau khi hiển thị popup
    saveBuffetToLocalStorage(buffetData)
  }
}
